<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{name: 'BasicInfo'}">
              <h4 class="ms-2">
                {{label.sidebar.basicInfo}}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
            </h4>
          </b-col>
          <b-col cols="2" class="text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title="label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <DxDataGrid
              :show-row-lines="true"
              :show-column-lines="true"
              :show-borders="true"
              :row-alternation-enabled="true"
              :rtl-enabled="true"
              :data-source="items"
              :columns="fields"
              :remote-operations="true"
              :column-auto-width="true"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              column-resizing-mode="widget"
              :hover-state-enabled="true"
              :noDataText="checkData"
              @toolbar-preparing="onToolbarPreparing($event)"
              key-expr="id"
              class="ps_Table"
              :height="dataGridHeight"
          >
            <DxSearchPanel
                :visible="true"
                :width="240"
                :placeholder="label.pages.search"
            />
            <template #btnRGroup>
              <div></div>
            </template>
            <template #btnGroup>
              <div>
                <b-row class="ms-1">
                  <b-col cols="auto" class="px-0 ms-1">
                    <b-button
                            variant="ps-success"
                            class="py-1 pb-2"
                            size="sm"
                            v-b-tooltip.hover
                            :title="label.buttons.add"
                            @click="add"
                    >
                      <b-icon icon="plus" scale="2" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                  <b-col cols="auto" class="px-0">
                    <b-button
                        variant="ps-secondary"
                        class="py-1 pb-2"
                        size="sm"
                        v-b-tooltip.hover
                        :title="label.buttons.reload"
                        @click="reloadData"
                    >
                      <b-icon icon="arrow-repeat" scale="1.5" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
            <template #radif="{data}">
              <div>
                {{ data.rowIndex + 1 }}
              </div>
            </template>
            <template #actions="{data}">
              <b-row class="justify-content-center">
                <b-col cols="auto" class="px-1">
                  <button
                      @click="edit(data)"
                      :id="'editBtnTlp-' + data.data.id"
                  >
                    <b-icon icon="dash-square-fill" scale="1.1" variant="ps-edit-icon"></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'editBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.edit }}
                  </b-tooltip>
                </b-col>
                <b-col cols="auto" class="px-0">
                  <button
                          @click="delConfirm(data)"
                          :id="'deleteBtnTlp-' + data.data.id"
                  >
                    <b-icon icon="x-square-fill" scale="1.1" variant="ps-delete-icon"></b-icon>
                  </button>
                  <b-tooltip
                          boundary="#app"
                          noninteractive
                          triggers="hover"
                          :target="'deleteBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.delete }}
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <DxLoadPanel :enabled="true"/>
            <DxScrolling mode="virtual"/>
          </DxDataGrid>
        </b-card-text>
      </b-card-body>
    </b-card>


    <!--  Add Modal -->
    <b-modal
            dir="rtl"
            v-model="addModal"
            header-bg-variant="ps-success"
            size="sm"
            centered
    >
      <template #modal-header>
        <h4 class="text-white mb-0 fw1">
          {{label.pages.recordOfCategory}}
        </h4>
        <button
                class="ps-closeModalBtn"
                @click="addModal=false"
                id="closeAddModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
                boundary="#app"
                noninteractive
                triggers="hover"
                target="closeAddModalTlp"
        >
          {{ label.pages.closeTab }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row>
          <b-col cols="12">
            <label for="title" class="ps_label pe-2">
              {{label.pages.title}}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input id="title" size="sm" v-model="form.title"/>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                    variant="ps-secondary"
                    size="sm"
                    class="mx-1"
                    @click="addModal=false"
            >
              {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                    v-if="!loadingBtn"
                    variant="ps-success"
                    size="sm"
                    class="mx-1"
                    @click="addItem"
            >
              {{label.buttons.newCategory}}
            </b-button>
            <b-button
                    v-else
                    variant="ps-success"
                    size="sm"
                    class="mx-1"
                    disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>


    <!-- edit Modal -->
    <b-modal
        dir="rtl"
        v-model="editModal"
        header-bg-variant="ps-warning"
        size="sm"
        centered
    >
      <template #modal-header>
        <h4 class="text-white mb-0 fw1">
          {{label.pages.recordOfChange}}
        </h4>
        <button
            class="ps-closeModalBtn"
            @click="editModal=false"
            id="closeEditModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeEditModalTlp"
        >
          {{ label.pages.closeTab }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row>
          <b-col cols="12">
            <label for="title" class="ps_label pe-2">
              {{label.pages.title}}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input id="title" size="sm" v-model="form.title"/>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="editModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-warning"
                size="sm"
                class="mx-1"
                @click="editItem"
            >
            {{label.buttons.saveChanges}}
            </b-button>
            <b-button
                v-else
                variant="ps-warning"
                size="sm"
                class="mx-1"
                disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>


    <!-- Delete Confirm Modal -->
    <b-modal
            dir="rtl"
            v-model="delModal"
            hide-header
            size="sm"
            centered
    >
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 text-center">
            {{ label.captions.deleteConfirm}}
            <br />
            <strong>« {{ itemTitle }} »</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                    variant="ps-secondary"
                    size="sm"
                    class="mx-1"
                    @click="delModal=false"
            >
              {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                    v-if="!loadingBtn"
                    variant="ps-danger"
                    size="sm"
                    class="mx-1"
                    @click="deleteItem"
            >
              {{label.buttons.deleteConfirm}}
            </b-button>
            <b-button
                    v-else
                    disabled
                    variant="ps-danger"
                    size="sm"
                    class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {dataGridMixin} from '@/components/dataGrid/dataGridMixin'
import alert from '@/plugins/AlertMessages.js'
import label from "@/plugins/StaticLabels.js";

export default {
  name: 'TicketCategories',
  mixins: [dataGridMixin],
  data() {
    return {
      label,
      alert,
      fields: [
        {
          cellTemplate: 'radif',
          caption: 'ردیف',
          allowSorting: false,
          allowFiltering: false,
          width: '110',
          cssClass: 'text-center align-middle fs10'
        },
        {
          cellTemplate: 'actions',
          caption: 'عملیات',
          allowSorting: false,
          allowFiltering: false,
          width: '120',
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'title',
          caption: 'عنوان و نوع دسته بندی',
          dataType: 'string',
          cssClass: 'text-center align-middle fw2'
        },
      ],
      addModal: false,
      editModal: false,
      delModal: false,
      itemTitle: null,
      itemId: null,
      form: {
          title: null,
      },
    }
  },
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      items: 'baseX/ticketCategories',
      loadingBtn: 'loadingBtn',
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.closeModal();
        this.reloadData();
      }
    },
  },
  methods: {
    add() {
      this.reloadFields();
      this.addModal = true;
    },
    addItem() {
      if(this.form.title && this.form.title !== '') {
        this.$store.dispatch('baseX/addTicketCategory', this.form);
      } else {
        this.$store.commit('setError', alert.error.empty)
      }
    },
    edit(item) {
      this.itemId = item.data.id;
      this.form = {
        title: item.data.title,
      };
      this.editModal = true;
    },
    editItem() {
      if(this.form.title && this.form.title !== '') {
        const payload = {
          value: this.form,
          id: this.itemId,
        }
        this.$store.dispatch('baseX/editTicketCategory', payload);
      } else {
        this.$store.commit('setError', alert.error.empty)
      }
    },
    delConfirm(item) {
      this.itemTitle = item.data.title;
      this.itemId = item.data.id;
      this.delModal = true;
    },
    deleteItem() {
      this.$store.dispatch('baseX/deleteTicketCategory', this.itemId);
      this.closeModal();
    },
    closeModal() {
      this.addModal = false;
      this.editModal = false;
      this.delModal = false;
    },
    reloadFields() {
      this.form = {
        title: null,
      };
    },
    reloadData() {
      this.$store.dispatch('baseX/getTicketCategories');
    },
  },
  mounted() {
    this.reloadData();
  },
}
</script>
